import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import LogoMarquee from "@/components/LogoMarquee";
import Portfolio from "@/components/Portfolio";
import Stats from "@/components/Stats";
import WhyUs from "@/components/WhyUs";
import CaseStudies from "@/components/CaseStudies";
import Process from "@/components/Process";
import Pricing from "@/components/Pricing";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import Legal from "@/components/Legal";
import ThankYou from "@/components/ThankYou";

function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee />
        <Portfolio />
        <Stats />
        <WhyUs />
        <CaseStudies />
        <Process />
        <Pricing />
        <Faq />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, anchors: true }}>
      <div className="App min-h-screen bg-white">
        <Toaster theme="dark" position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/merci" element={<ThankYou />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
